import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDevices2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDevices2"><Path d="M23 21H15V9H23V21Z" fill="currentColor"/><Path d="M13 20.5H1V16H13V20.5Z" fill="currentColor"/><Path d="M21 7H13V14H3V3H21V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDevices2;
